import request from "@/utils/request1";

/**
 * 专家评审API接口
 */
const expertsReviewService = {};

let commonUrl = "/review-api";


expertsReviewService.expertExitReviewByExpert = function (params) {
    return request({
        url: "/experts-review-api/exit-review-by-expert",
        method: "post",
        baseURL: commonUrl,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        },
        data: params
    });
}

expertsReviewService.checkReviewExitUrl = function (id) {
    return request({
        url: "/experts-review-api/check-review-exit-url",
        method: "get",
        baseURL: commonUrl,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        },
        params: {
            id: id
        }
    });
}
export default expertsReviewService;
